import React, { FC } from 'react';
import {
  Box,
  Text,
  Divider,
  TextButton,
  Button,
  IconButton,
  CloseButton,
} from '@wix/design-system';
import { ArrowLeft } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './MobileFilterModalLayout.module.scss';

type Props = {
  title: string;
  content: any;
  dataHook?: string;
  onClear: () => void;
  onApply?: () => void;
  onClose?: () => void;
  onBack?: () => void;
  selectedAmount?: number;
};

const MobileFilterModalLayout: FC<Props> = ({
  title,
  content,
  onClear,
  onApply,
  dataHook,
  onClose,
  onBack,
  selectedAmount,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      dataHook={dataHook || 'mobile-filter-content'}
      direction="vertical"
      className={s.modal}
    >
      <div>
        <Box
          paddingLeft={onBack ? '14px' : '24px'}
          paddingRight="24px"
          paddingTop={onBack ? '15px' : '18px'}
          paddingBottom="12px"
          align="space-between"
        >
          <Box verticalAlign="middle">
            {onBack && (
              <Box paddingRight="12px">
                <IconButton
                  skin="light"
                  onClick={() => onBack()}
                  dataHook="modal-back-btn"
                  ariaLabel={t('marketplace-aria-label-modal-back-btn')}
                >
                  <ArrowLeft color="#000000" />
                </IconButton>
              </Box>
            )}
            <Text
              tabIndex={0}
              weight="bold"
              dataHook="mobile-filter-modal-title"
            >
              {title}
            </Text>
          </Box>
          {onClose && (
            <CloseButton
              dataHook="close-filter-modal"
              size="large"
              onClick={() => onClose()}
            />
          )}
        </Box>
      </div>
      <div className={s.modal__content}>{content}</div>
      <div>
        <Box direction="vertical">
          <Divider />
          <Box
            align="space-between"
            verticalAlign="middle"
            paddingTop="33px"
            paddingLeft="24px"
            paddingRight="24px"
            paddingBottom="33px"
          >
            <TextButton
              underline="always"
              skin="dark"
              dataHook="clear-all-mobile-filter-button"
              onClick={() => {
                onClear();
              }}
            >
              {t('mobile-filter-clear-all-with-amount', { selectedAmount })}
            </TextButton>
            {onApply && (
              <Button
                dataHook="apply-mobile-filter-button"
                onClick={() => {
                  onApply();
                }}
              >
                {t('mobile-filter-apply')}
              </Button>
            )}
          </Box>
        </Box>
      </div>
    </Box>
  );
};

export default MobileFilterModalLayout;
